import { callAPIPromise } from '@tabeeb/shared/utils/requests'
import { getPointCloudAccessToken } from '../actions'

const cache = new Map()

export const getToken = ({ pageId }) => {
  return new Promise((resolve, reject) => {
    if (!cache.has(pageId)) {
      cache.set(pageId, callAPIPromise(getPointCloudAccessToken.request({ pageId }), { callResultActions: false }))
    }

    resolve(cache.get(pageId))
  })
}

export const setPotreeToken = ({ token, pageId }) => {
  cache.set(pageId, { response: { data: { SasRead: token } } })
}
